import { IExtendedGrid, IExtendedGridItem } from '@/interfaces/grid.interfaces';

import instanceOfGrid from './instanceOfGrid';

class GridUtils {
  /**
   * Рекурсивно ищет элемент Grid-а, по ID.
   */
  findById<Item extends IExtendedGridItem, Grid extends IExtendedGrid<Item>>(
    grid: Grid,
    id: Grid['id'],
  ): Item | Grid | undefined {
    if (grid.id === id) {
      return grid;
    }

    for (const item of grid.items) {
      if (instanceOfGrid(item)) {
        const foundItem = this.findById(item, id);

        if (foundItem) {
          return foundItem as Item | Grid;
        }
      } else if (item.id === id) {
        return item;
      }
    }
  }

  /**
   * Рекурсивно ищет элемент Grid-а, соответствующий условию.
   * @param grid Грид для поиска элемента
   * @param condition Функция условия
   * @returns Элемент грида, саб-грид или undefined в случае, если элемент не найден.
   */
  findByCondition<Item extends IExtendedGridItem, Grid extends IExtendedGrid<Item>>(
    grid: Grid,
    condition: (element: Item | Grid) => boolean,
  ): Item | Grid | undefined {
    if (condition(grid)) {
      return grid;
    }

    for (const item of grid.items) {
      if (instanceOfGrid(item)) {
        const foundItem = this.findByCondition(item as Grid, condition);

        if (foundItem) {
          return foundItem;
        }
      } else if (condition(item)) {
        return item;
      }
    }
  }
}

export default new GridUtils();
